import { ToolbarSplitDropdownElement } from './ToolbarSplitDropdownElement'

const overlayElementTemplate = `
<div class="wrapper">
  <div class="toolbar-list-row">
      <div class="toolbar-list-item toolbar-list-item-ol-1"></div>
      <div class="toolbar-list-item toolbar-list-item-ol-2"></div>
      <div class="toolbar-list-item toolbar-list-item-ol-3"></div>
  </div>
  <div class="toolbar-list-row">
      <div class="toolbar-list-item toolbar-list-item-ul-1"></div>
      <div class="toolbar-list-item toolbar-list-item-ul-2"></div>
      <div class="toolbar-list-item toolbar-list-item-ul-3"></div>
  </div>
</div>
`

export class ToolbarListElement extends ToolbarSplitDropdownElement {
  public override setFormat(format: { [key: string]: Set<any> }): void {
    this.overlayElement.querySelectorAll('.toolbar-list-item.selected').forEach((item) => {
      item.classList.remove('selected')
    })
    if (format[this.name]) {
      this.overlayElement.querySelectorAll('.toolbar-list-item').forEach((item) => {
        if (format[this.name].has((item as HTMLElement).dataset.value)) {
          item.classList.add('selected')
        }
      })
    }
  }

  protected override initDom() {
    super.initDom()
    this.entryElement.classList.add('toolbar-split-dropdown-list')
    this.overlayElement.innerHTML = overlayElementTemplate
    this.overlayContainer.append(this.overlayElement)
  }
}
